import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { userService } from "services/userService";
import { RootState } from "store";

export default function useVoucherList() {
  const { language } = useSelector((state: RootState) => state.lang);

  const [vouchers, setVouchers] = useState<any[] | null>(null);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const result = await userService.getUserVouchers({
        isGrouped: true,
        language: language as "en" | "tc",
      });

      if (!result) return;

      setVouchers(result);
    })();
  }, [language]);

  const _onOpen = (): void => {
    setIsShowModal(true);
  };

  const _onClose = (): void => {
    setIsShowModal(false);
  };

  return { isShowModal, vouchers, _onOpen, _onClose };
}
